export default "__VITE_ASSET__CHahFjZM__"